import React from 'react';
import { Clipboard, ClipboardPaste, X, AlertTriangle } from 'lucide-react';
import './ClipboardBanner.css';

type ClipboardPlatform = 'graia' | 'ryan';

interface ClipboardBannerProps {
    count: number;
    onPaste: () => void;
    onClear: () => void;
    sourcePlatform?: ClipboardPlatform | 'mixed' | null;
    currentPlatform?: ClipboardPlatform;
}

const PLATFORM_LABEL: Record<ClipboardPlatform, string> = {
    graia: 'GRAIA',
    ryan: 'RYAN',
};

export const ClipboardBanner: React.FC<ClipboardBannerProps> = ({
    count, onPaste, onClear, sourcePlatform = null, currentPlatform = 'graia'
}) => {
    if (count === 0) return null;

    const isCrossPlatform = sourcePlatform !== null && sourcePlatform !== currentPlatform;

    let text: string;
    if (sourcePlatform === 'mixed') {
        text = 'Cards copiados de plataformas diferentes — revise antes de colar';
    } else if (isCrossPlatform && sourcePlatform) {
        text = count === 1
            ? `1 flashcard copiado do ${PLATFORM_LABEL[sourcePlatform]} — colar aqui no ${PLATFORM_LABEL[currentPlatform]}?`
            : `${count} flashcards copiados do ${PLATFORM_LABEL[sourcePlatform]} — colar aqui no ${PLATFORM_LABEL[currentPlatform]}?`;
    } else {
        text = count === 1
            ? '1 flashcard copiado'
            : `${count} flashcards copiados`;
    }

    return (
        <div className={`clpb-banner${isCrossPlatform ? ' clpb-banner--cross-platform' : ''}`}>
            <div className="clpb-left">
                {isCrossPlatform
                    ? <AlertTriangle size={16} className="clpb-icon" />
                    : <Clipboard size={16} className="clpb-icon" />}
                <span className="clpb-text">{text}</span>
            </div>
            <div className="clpb-actions">
                <button
                    type="button"
                    className="clpb-btn clpb-btn-paste"
                    onClick={onPaste}
                    title="Colar flashcards aqui"
                >
                    <ClipboardPaste size={14} />
                    <span>Colar</span>
                </button>
                <button
                    type="button"
                    className="clpb-btn clpb-btn-clear"
                    onClick={onClear}
                    title="Limpar clipboard"
                >
                    <X size={14} />
                </button>
            </div>
        </div>
    );
};